import CheckIndicator from 'img/icons/check_indicator_small.svg';
import RequestedIndicator from 'img/icons/requested_small.svg';
import ScheduledIndicator from 'img/icons/scheduled-calendar-indicator.svg';
import UnavailableIndicator from 'img/icons/cross_indicator_small.svg';
import { TFunction } from 'react-i18next';
import { PremiumSessionUserFacingStatus } from 'types/premiumSession';
import {
  BodyRowType,
  HeaderIconConfig,
  IconType,
  OfferingTypeConfig,
} from '../utils/types';
import { formatPremiumSessionRows } from '../BodyBuilder/utils';

const getPremiumSessionIconConfig = (
  status: PremiumSessionUserFacingStatus,
  t: TFunction<'translation', undefined>,
): HeaderIconConfig => {
  let src = '';

  switch (status) {
    case PremiumSessionUserFacingStatus.Attended:
      src = CheckIndicator;
      break;
    case PremiumSessionUserFacingStatus.Enrolled:
      src = ScheduledIndicator;
      break;
    case PremiumSessionUserFacingStatus.Requested:
      src = RequestedIndicator;
      break;
    case PremiumSessionUserFacingStatus.Unavailable:
      src = UnavailableIndicator;
      break;
    default:
      break;
  }

  return {
    backgroundColor: '#f0f0f0',
    iconTitle: t('Premium Session Icon'),
    src,
  };
};

const premiumSessionConfig: OfferingTypeConfig = {
  actionButtons: ({
    isLocked,
    premiumSessionSlug,
    premiumSessionStatus,
    routerStore,
    sessionDocId,
    t,
  }) => {
    let buttonLabel = t('View');

    if (
      premiumSessionStatus === PremiumSessionUserFacingStatus.Schedulable &&
      !isLocked
    ) {
      buttonLabel = t('Schedule');
    } else if (
      premiumSessionStatus === PremiumSessionUserFacingStatus.Unavailable &&
      !isLocked
    ) {
      buttonLabel = t('Request');
    }

    const isScheduleRoute =
      premiumSessionStatus === PremiumSessionUserFacingStatus.Schedulable ||
      premiumSessionStatus === PremiumSessionUserFacingStatus.Unavailable ||
      premiumSessionStatus === PremiumSessionUserFacingStatus.Requested;

    const routeName = isScheduleRoute
      ? 'premium:sessions:schedule'
      : 'sessions:view';
    const routeParams = isScheduleRoute
      ? { sessionslug: premiumSessionSlug }
      : {
          sessionid: sessionDocId,
          sessionslug: premiumSessionSlug,
          uuid: sessionDocId,
        };

    return {
      actionButtonA: {
        buttonLabel,
        href: routerStore.router.buildUrl(routeName, routeParams),
        icon: IconType.Arrow,
        onClick: () => routerStore.navigate(routeName, routeParams),
      },
    };
  },
  bodyRowsLayout: () => [BodyRowType.Custom],
  buildCustomRows: ({
    attendedSessionDate,
    premiumSessionStatus,
    schedulledSessionDate,
    t,
  }) =>
    formatPremiumSessionRows(
      premiumSessionStatus,
      attendedSessionDate,
      schedulledSessionDate,
      t,
    ),
  headerConfig: ({ premiumSessionStatus, t }) => ({
    iconB: getPremiumSessionIconConfig(premiumSessionStatus, t),
    title: t('Session'),
  }),
};

export default premiumSessionConfig;
